module.exports = __webpack_public_path__ + "img/446.f99208d3.jpg";